<template>
    <div class="bg-white rounded-lg overflow-hidden shadow group border transition-all cursor-pointer p-2">

        <div class="w-full aspect-video relative rounded-lg overflow-hidden">
            <LoadContainer class="w-full h-full" />
        </div>

        <div class="p-4 text-slate-600 bg-white transition-all mt-2 rounded-lg">

            <div class="flex items-center justify-start mb-3 gap-3">
                <LoadItem class="w-24 h-6 rounded" /> -
                <LoadItem class="w-24 h-6 rounded" />
            </div>
            <LoadContainer class="h-8" />

        </div>
    </div>
</template>

<script setup lang="ts">
import LoadContainer from './LoadContainer.vue';
import LoadItem from './LoadItem.vue';
</script>